import axiosClient from "./axiosClient";

type PreloadAuth = {
  externalUserKey: number;
  userToken: string;
  companyKey: number;
  companyApiKey: string;
};

export const preloadApi = {
  getPreload: (auth: PreloadAuth) => {
    return axiosClient.post("/preload", auth);
  },
};